"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAmenityTouchless(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.9 614.8c8 0 13.7 4.9 16 10.7C690 715.4 771.1 784.7 875 806.2c6.9 1 11.4 6.8 12.6 12.7 0 6.8-5.7 11.7-12.6 13.7-102.8 21.5-186.2 91.8-210.1 180.7-2.3 6.8-8 10.7-16 10.7s-13.7-4.9-16-10.7C607.8 925.4 525.6 855 422.8 833.6c-8-2-12.6-6.8-12.6-13.7 0-6.8 5.7-11.7 12.6-13.7 103.9-21.5 185-90.8 210.1-180.7 2.3-6.8 8-10.7 16-10.7zM307.4 136.4h.3c7.4.1 13.6 4.4 14.7 11.8 29 141.6 139.7 252.1 280.5 281.1 6.4 2.1 11.8 7.5 11.8 15s-5.4 12.9-11.8 15c-140.8 29-251.5 139.5-280.5 280-2.1 6.4-7.5 11.8-15 11.8s-14-4.3-15-11.8c-29-140.6-139.7-251.1-280.5-280-6.4-2.1-11.8-7.5-11.8-15s5.4-13.9 11.8-15c140.8-29 251.5-139.5 280.5-281.1 2.1-6.4 7.5-11.8 15-11.8zM784.2 0c8 0 13.7 4.9 16 10.7 25.1 89.8 106.2 159.2 210.1 180.7 8 1 12.6 6.8 13.7 13.7 0 6.8-5.7 11.7-12.6 13.7l-3.1.7c-101.4 22.2-182.2 92-207.1 179-2.3 6.8-8 10.7-16 10.7s-13.7-4.9-16-10.7c-25-87.9-107.2-158.3-210-179.7-8-2-12.6-6.8-12.6-13.7s5.7-11.7 12.6-13.7c103.9-21.5 185-90.8 209-180.7 2.3-6.8 8-10.7 16-10.7z"
  }));
}

var ForwardRef = React.forwardRef(SvgAmenityTouchless);
var _default = ForwardRef;
exports.default = _default;